import { Route } from 'react-router-dom';

// import { PrivateRoute } from 'src/screens/app/routes/user/user.utils';

const exampleRouteGroup = <Route path="example"></Route>;

export default exampleRouteGroup;
